import { render, staticRenderFns } from "./identityVerify.vue?vue&type=template&id=7dbf00c6"
import script from "./identityVerify.vue?vue&type=script&lang=ts"
export * from "./identityVerify.vue?vue&type=script&lang=ts"
import style0 from "./identityVerify.vue?vue&type=style&index=0&id=7dbf00c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports